import BaseQuery from "@/stateManagement/BaseQuery";
import { ATTRIBUTE_TYPE } from "@apps/reviews/constants";
import { map, mergeAll } from "rxjs";
import { injectable } from "tsyringe";
import * as Yup from "yup";

import ReviewsFilterStore, {
    ReviewsFilterState,
} from "../stores/ReviewsFilterStore";

export type AttributesFilterSchema = { [key: string]: Yup.AnySchema };

@injectable()
class ReviewsFilterQuery extends BaseQuery<ReviewsFilterState> {
    constructor(protected store: ReviewsFilterStore) {
        super(store);
    }

    reviewsFilter$ = this.select((state) => state);

    customerFilters$ = this.select((state) => state.data.customerFilters);
    productFilters$ = this.select((state) => state.data.productFilters);

    all$ = this.select((state) => {
        return [...state.data.customerFilters, ...state.data.productFilters];
    });

    status$ = this.selectStatus();
    error$ = this.selectError();

    schema$ = this.all$.pipe(
        mergeAll(),
        map((data) => data)
    );

    customerFiltersSchema$ = this.customerFilters$.pipe(
        map((filter) => {
            const schema: AttributesFilterSchema = {};

            filter.forEach((a) => {
                if (
                    [
                        ATTRIBUTE_TYPE.SINGLE_VALUE,
                        ATTRIBUTE_TYPE.LOCATION,
                        ATTRIBUTE_TYPE.DATE,
                    ].includes(a.content.type)
                ) {
                    Yup.string();
                }

                if (a.content.type === ATTRIBUTE_TYPE.MULTI_VALUE) {
                    schema[a.id] = Yup.array().of(Yup.string());
                }
            });

            return schema;
        })
    );

    productFiltersSchema$ = this.productFilters$.pipe(
        map((filter) => {
            const schema: AttributesFilterSchema = {};

            filter.forEach((a) => {
                if (
                    [
                        ATTRIBUTE_TYPE.TEXTFIELD,
                        ATTRIBUTE_TYPE.SINGLE_VALUE,
                    ].includes(a.content.type)
                ) {
                    Yup.string();
                }

                if (a.content.type === ATTRIBUTE_TYPE.MULTI_VALUE) {
                    schema[a.id] = Yup.array().of(Yup.string());
                }

                if (
                    [
                        ATTRIBUTE_TYPE.RANGE,
                        ATTRIBUTE_TYPE.CENTERED_RANGE,
                    ].includes(a.content.type)
                ) {
                    Yup.number().typeError("validation_field_required");
                }
            });

            return schema;
        })
    );
}

export default ReviewsFilterQuery;
